import { createContext, useEffect, useState } from 'react'
import { useApi } from 'hooks/useApi/useApi'

export const CountingContext = createContext()

export const CountingProvider = ({ children, countingId }) => {
    const {counting, fetchCounting, updateCounting, setCounting} = useApi()
    const [itemsCountedTotalAmount, setItemsCountedTotalAmount] = useState(0)

    useEffect(() => {
        setItemsCountedTotalAmount(0)
        fetchCounting(countingId)
    }, [countingId])

    return (
        <CountingContext.Provider value={{counting, updateCounting, setCounting, fetchCounting, itemsCountedTotalAmount, setItemsCountedTotalAmount}}>
            {children}
        </CountingContext.Provider>
    )
}

